export default __webpack_public_path__ + "static/media/8.92427534.webp";